import type { AttentionRow } from "./attention-rows.js";
import type { FollowUp } from "./followups-api.js";

const temperatureTypes = new Set([
  "cook",
  "cooling",
  "hot_smoke",
  "reheat",
  "sous_vide",
  "temperature",
]);

// A type, not an interface, so it fits the router's search parameters.
export type IncidentSearch = {
  category?: string;
  follow_up_id: string;
  record_type_code: "incident";
  what_went_wrong: string;
};

// "Record as incident" opens Report a problem with what is already known
// filled in. Saving it closes the follow-up as escalated.
export function incidentSearch(
  followUp: Pick<FollowUp, "id" | "trigger_kind">,
  row: Pick<AttentionRow, "detail" | "title">,
  recordTypeCode?: string,
): IncidentSearch {
  const category =
    followUp.trigger_kind === "rejected_delivery"
      ? "supplier"
      : recordTypeCode && temperatureTypes.has(recordTypeCode)
        ? "temperature"
        : undefined;
  return {
    ...(category ? { category } : {}),
    follow_up_id: followUp.id,
    record_type_code: "incident",
    what_went_wrong: [row.title, ...row.detail].filter(Boolean).join(" · "),
  };
}
